<template>
  <generic-modal :title="$t('policy')" ref="generic_modal" :is_wide="true">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date") }}</label>
          <div class="control">
            <input class="input" type="date" v-model="meta.date" />
          </div>
        </div>
      </div>
      <!-- <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div> -->
      <div class="column">
        <div class="title is-4 has-text-warning is-pulled-right">
          {{ $t("debit") }}: {{ format_currency(total.debit) }}
        </div>
        <div class="title is-4 has-text-primary">
          {{ $t("credit") }}: {{ format_currency(total.credit) }}
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("type") }}</label>
          <div class="control">
            <div class="select">
              <select v-model="meta.type">
                <option value="debit">{{ $t("debit") }}</option>
                <option value="credit">{{ $t("credit") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('policy type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/accounting/policy-type/catalog"
            name_field="name"
            value_field="policy_type_id"
            @selected="set_policy_type"
            ref="policy_type_dropdown"
          />
        </div>
      </div>
    </div>
    <transactions ref="transactions" @total="update_total" />
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import Transactions from "./Transactions.vue";

export default {
  name: "AccountingPolicyModal",
  components: { GenericModal, Transactions, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
      total: {
        debit: 0,
        credit: 0,
      },
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.date || v.total.debit != v.total.credit;
    },
  },
  methods: {
    format_currency,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/accounting/policy", { uuid: uuid })
        .then((policy) => {
          v.meta = policy;
          let transactions = [...policy.accounting_transactions];
          delete v.meta.accounting_transactions;
          if (transactions) v.$refs.transactions.set_transactions(transactions);

          if (policy.policy_type_id)
            v.$refs.policy_type_dropdown.set_value(policy.policy_type_id);
        })
        .catch((error) => {
          console.log(error);
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    show_modal() {
      let v = this;
      // let account_uuid = v.$route.params.enterprise_uuid;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.error = "";
      let data = { ...v.meta };
      data.period_uuid = v.$route.params.period_uuid;

      data.transactions = v.$refs.transactions.get_transactions();

      if (!data.transactions.length) {
        v.error = v.$t("please add at least one transaction");
        return;
      } else {
        if (
          data.transactions.find((t) => {
            return (
              !t.account_id || isNaN(t.credit) || isNaN(t.debit) || !t.name
            );
          })
        ) {
          v.error = v.$t("please fill all transaction fields");
          return;
        }
      }

      if (!v.meta.uuid) {
        put("/accounting/policy", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else
        post("/accounting/policy", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      v.total = {
        debit: 0,
        credit: 0,
      };
      v.$refs.transactions.clear();
      v.$refs.policy_type_dropdown.clear();
      // v.uuid = "";
    },
    update_total(total) {
      // console.log(total);
      let v = this;
      v.total = total;
    },
    set_policy_type(policy_type) {
      if (policy_type) {
        let v = this;
        v.meta.policy_type_id = policy_type.policy_type_id;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
